export const buildVariables: any = {"buildNumber":"20260719.1","buildDate":"2026-07-19 09:03:47-04:00","buildCommitMessage":"Merge tag '9.5' into develop","svgSpritePath":"/assets/sprite/icons-5a984c11.svg"};
